export var MOBILE_ALIGNMENT = 'center';
export var LARGE_DEVICE_ALIGNMENT = 'left';